import React from 'react';

const BranchIcon = ({ fill }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <mask
        id='mask0_2276_6506'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <path d='M24 0H0V24H24V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_2276_6506)'>
        <path
          d='M21.1392 5.88417C20.5992 4.58833 19.3425 3.75 17.9383 3.75H6.06167C4.6575 3.75 3.40083 4.5875 2.86083 5.88417L1.5 9.15V10.3983C1.5 11.5317 2.30583 12.4808 3.375 12.7017V21H20.625V12.7017C21.6942 12.4808 22.5 11.5317 22.5 10.3983V9.15L21.1392 5.88417ZM19.0625 6.74917L20.25 9.6V10.3983C20.25 10.4542 20.2042 10.5 20.1483 10.5H18.75L17.115 6H17.9392C18.4325 6 18.8733 6.29417 19.0625 6.74917ZM10.875 10.5H7.8925L9.35167 6H10.8758V10.5H10.875ZM13.125 6H14.72L16.355 10.5H13.1242V6H13.125ZM3.85167 10.5C3.79583 10.5 3.75 10.4542 3.75 10.3983V9.6L4.9375 6.74917C5.1275 6.29417 5.56833 6 6.06083 6H6.985L5.52583 10.5H3.85083H3.85167ZM18.375 18.75H5.625V12.75H18.375V18.75Z'
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default BranchIcon;
